import { useSelector } from 'react-redux';
import DefaultWidgetTemplate from '../DefaultWidgetTemplate';

export default function RiskManagerDefaultWidget({ module }) {
  const global = useSelector((state) => state.global);
  return (
    <DefaultWidgetTemplate
      module={module}
      oldRoute={`${global?.urlData?.rootProject}risk-manager/home/${
        module[module.name].slug
      }/`}
    />
  );
}
